module.exports = __webpack_public_path__ + "img/img26.268608be.png";